let startScrollPosY = -1.0;
let scrollDiff = 0;
let completed = false;
const scrollLimit = 1500;
const cmsRoutine = document.querySelector(".cms-routine");
const routineHeader = document.querySelector(".routine-header");
const circle = document.querySelector(".routine-circle");
const steppingElements = document.querySelectorAll(".stepping-header");
const hpRoutine = document.querySelector("#routine-element");
const disclaimer = document.querySelector(".routine-disclaimer");

function reset() {
    if (steppingElements && steppingElements.length > 0) {
        steppingElements.forEach((element) => {
            makeInvisible(element);
        });
        makeInvisible(circle);
        startScrollPosY = -1;
        scrollDiff = 0;
        completed = false;
    }
}

let handlingScroll = false;

function setAbsolute() {
    hpRoutine.style.position = "absolute";
    hpRoutine.style.top = "unset";

    if (scrollDiff > scrollLimit) {
        window.scroll({left: 0, top: startScrollPosY, behavior: "instant"});
        scrollDiff = 0;
        completed = true;
    }

    removePseudoelement();

    startScrollPosY = -1;
    handlingScroll = false;
}

function handleScroll() {
    if (handlingScroll) {
        return;
    }

    if (!hpRoutine) {
        return;
    }

    if (completed === true) {
        if (window.scrollY < 1000 && !document.documentElement.classList.contains('scrolling')) {
            reset();
        } else {
            return;
        }
    }

    handlingScroll = true;
    if (startScrollPosY !== -1) {
        if (window.scrollY < (startScrollPosY - 100) || scrollDiff > scrollLimit) {
            setAbsolute();
            return;
        }

        scrollDiff = window.scrollY - startScrollPosY;

        checkVisibleScrollRange(routineHeader, 0, scrollLimit);
        checkVisibleScrollRange(circle, 50, scrollLimit);

        if (scrollDiff > 50) {
            drawCanvas(100 / (50 - scrollLimit) * (50 - scrollDiff));
            checkVisibleScrollRange(disclaimer, 0, scrollLimit);
        }

        if (steppingElements && steppingElements.length > 0) {
            [...steppingElements].map((element, index) => {
                checkVisibleScrollRange(element, 80 + (index * 300), scrollLimit);
            });
        }
    } else {
        if (hpRoutine.getBoundingClientRect().top - 100 <= 0 &&
            hpRoutine.getBoundingClientRect().bottom > 200 &&
            completed === false) {
            startScrollPosY = window.scrollY;
            hpRoutine.style.position = "fixed";
            hpRoutine.style.top = "110px";
            addPseudoelement();
        } else if (hpRoutine.getBoundingClientRect().bottom < 0 &&
            completed === false) {
            setCompleted();
        }
    }

    handlingScroll = false;
}

function setCompleted() {
    if (steppingElements && steppingElements.length > 0) {
        steppingElements.forEach((element) => {
            makeVisible(element);
        });
        makeVisible(circle);
        scrollDiff = 0;
        completed = true;
    }
}

window.addEventListener('scroll-start', function () {
    setAbsolute();
    setCompleted();
});


function addPseudoelement() {
    if (cmsRoutine && !cmsRoutine.querySelector("#pseudo-element")) {
        const pseudoElement = document.createElement("div");
        if (pseudoElement) {
            pseudoElement.style.width = "100%";
            pseudoElement.style.height = scrollLimit + 100 + "px";
            pseudoElement.innerHTML = "&nbsp;";
            pseudoElement.id = "pseudo-element";
            cmsRoutine.appendChild(pseudoElement);
        }
    }
}

function removePseudoelement() {
    if (cmsRoutine) {
        const pseudoElement = cmsRoutine.querySelector("#pseudo-element");
        if (pseudoElement) {
            cmsRoutine.removeChild(pseudoElement);
        }
    }
}

function makeVisible(element) {
    element.style.visibility = "visible";
    element.style.opacity = "1";
}

function makeInvisible(element) {
    element.style.visibility = "hidden";
    element.style.opacity = "0";
}

function checkVisibleScrollRange(element, from, to) {
    if (scrollDiff >= from && (scrollDiff <= to || to >= scrollLimit)) {
        makeVisible(element);
    } else {
        makeInvisible(element);
    }
}

function setSteppingHeadersEvents() {
    const steppingElements = document.querySelectorAll(".stepping-container");
    if (steppingElements) {
        steppingElements.forEach((steppingElement) => {
            const steppingText = steppingElement.querySelector(".stepping-text");
            if (steppingText) {
                steppingElement.addEventListener("mouseover", () => {
                    let steppingHeader = steppingElement.querySelector(".stepping-header");

                    //no mouseover when hidden
                    if (steppingHeader.style.visibility === "hidden") {
                        return;
                    }

                    steppingText.style.display = "flex";
                    if (window.matchMedia("(min-width: 770px)").matches) {
                        steppingElement.style.position = "relative";
                        steppingText.style.maxWidth = "unset";
                        if (steppingHeader) {
                            let styleHeader = window.getComputedStyle(steppingHeader);
                            steppingText.style.left = (parseInt(styleHeader.left)
                                - Math.round(parseInt(styleHeader.width) / 2.0)) + "px";
                            steppingText.style.top = (parseInt(styleHeader.top) - 20) + "px";
                            steppingText.style.width = (parseInt(styleHeader.width) * 2) + "px";
                        }
                    }
                });
                steppingElement.addEventListener("mouseout", () => {
                    steppingText.style.display = "none";
                    if (window.matchMedia("(min-width: 770px)").matches) {
                        steppingElement.style.position = "unset";
                        steppingText.style.width = "80vw";
                        steppingText.style.maxWidth = "100%";
                        steppingText.style.left = "0";
                        steppingText.style.top = "unset";
                    }
                });
            }
        });
    }
}

function drawCanvas(percentage) {
    const container = document.querySelector(".routine-circle");

    // Get the canvas element and its context
    const canvas = document.getElementById('circle-canvas');
    const ctx = canvas.getContext('2d');

    // Get the container's computed width and height
    const containerWidth = container.clientWidth;
    const containerHeight = container.clientHeight;

    // Set canvas dimensions to match the container
    canvas.width = containerWidth;
    canvas.height = containerHeight;

    // Set the circle attributes
    const circleRadius = Math.min(containerWidth, containerHeight) * 0.5; // Adjust circle size as a fraction of container size
    const lineWidth = 4;

    // Calculate the start and end angles for the arc
    const startAngle = -Math.PI / 2; // 12 o'clock position
    const endAngle = startAngle + ((percentage / 100) * (Math.PI * 2));

    // Set up canvas style
    ctx.lineWidth = lineWidth;
    ctx.strokeStyle = 'white';
    ctx.fillStyle = 'transparent';

    // Draw the circle
    ctx.beginPath();
    ctx.arc(containerWidth / 2, circleRadius, circleRadius - lineWidth / 2, startAngle, endAngle);
    ctx.stroke();
    ctx.closePath();
}

window.addEventListener("scroll", () => {
    handleScroll();
});

window.addEventListener("load", () => {
    setSteppingHeadersEvents();
});
document.addEventListener("DOMContentLoaded", function () {
    if (typeof AOS !== 'undefined') {
        AOS.init();
    }
});

document.addEventListener('DOMContentLoaded', () => {
    const video = document.querySelector(".image-wrapper video");
    const playBtn = document.querySelector(".play-button");

    function hidePlayButton() {
        playBtn.style.display = "none";
    }

    playBtn.addEventListener('click', () => {
        video.play();
        hidePlayButton();
    });

    video.addEventListener('play', hidePlayButton);
    video.addEventListener('pause', () => {
        if (!video.ended) playBtn.style.display = "block";
    });
    video.addEventListener('ended', () => {
        playBtn.style.display = "block";
    });
});

function handleBenefitToggle(triggerElement, targetSelector) {
const moreBenefitsGrid = document.querySelector(targetSelector);

if (moreBenefitsGrid.classList.contains("hidden")) {
    moreBenefitsGrid.classList.remove("hidden");
    triggerElement.textContent = "Weniger Benefits sehen";
} else {
    moreBenefitsGrid.classList.add("hidden");
    triggerElement.textContent = "Mehr Benefits sehen";
}
}
document.addEventListener("DOMContentLoaded", () => {
    const startCounting = (element, start, end, duration) => {
    let startTime = null;

    const step = (timestamp) => {
        if (!startTime) startTime = timestamp;
        const progress = Math.min((timestamp - startTime) / duration, 1);
        element.textContent = Math.floor(progress * (end - start) + start);
        if (progress < 1) {
        requestAnimationFrame(step);
        }
    };

    requestAnimationFrame(step);
    };

    const addAnimation = (elements, { sequential = false, delay = 200, callback = null } = {}) => {
    if (sequential) {
        elements.forEach((element, index) => {
        setTimeout(() => {
            if (callback) {
            callback(element);
            } else {
            element.classList.add("animated");
            }
        }, index * delay);
        });
    } else {
        elements.forEach((element) => {
        if (callback) {
            callback(element);
        } else {
            element.classList.add("animated");
        }
        });
    }
    };

    const observeElements = (selector, onIntersect, options = { threshold: 0.5 }) => {
    const elements = document.querySelectorAll(selector);
    const observer = new IntersectionObserver((entries, observerInstance) => {
        entries.forEach((entry) => {
        if (entry.isIntersecting) {
            onIntersect(entry.target);
            observerInstance.unobserve(entry.target);
        }
        });
    }, options);

    elements.forEach((element) => observer.observe(element));
    };

    observeElements(".stat-number", (target) => {
    if (!target.classList.contains("counted")) {
        const endValue = parseInt(target.textContent, 10);
        target.textContent = "0";
        startCounting(target, 0, endValue, 2000);
        target.classList.add("counted");
    }
    target.classList.add("visible");
    });

    observeElements(".benefits-container", () => {
    const benefitItems = document.querySelectorAll(".benefits-container .benefit-item");
    addAnimation(benefitItems, { sequential: true, delay: 200 });
    });

    observeElements(".supplements-teaser", () => {
    const benefitItems = document.querySelectorAll(".supplements-teaser .benefit-item");
    addAnimation(benefitItems, { sequential: true, delay: 200 });
    });

    observeElements(".final-price", (target) => {
    target.classList.add("animated");
    });

});

// Sticky CTA for product form
document.addEventListener('DOMContentLoaded', function () {
    const stickyCTA = document.getElementById('sticky-cta');
    if (!stickyCTA) return;

    const originalSubmitBtn = document.querySelector('product-form[data-loop-product-id="{{ product.id }}"]');
    const stickySubmitBtn = document.getElementById('sticky-submit-btn');

    function toggleStickyCTA() {
            const originalBtnRect = originalSubmitBtn.getBoundingClientRect();
            const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
            if (originalBtnRect.bottom - 90 < 0) {
            stickyCTA.classList.remove('hidden');
            } else {
            stickyCTA.classList.add('hidden');
            }
    }

    stickySubmitBtn.addEventListener('click', function () {
            const subscriptionContainer = document.querySelector('.subscription-container');
            const containerRect = subscriptionContainer.getBoundingClientRect();
            const scrollOffset = window.scrollY || window.pageYOffset;
            
            window.scrollTo({
            top: containerRect.top + scrollOffset - 50 - 90, 
            behavior: 'smooth'
            });
    });

    window.addEventListener('scroll', toggleStickyCTA);
    toggleStickyCTA();
});

// Footnotes toggle functionality
document.addEventListener('DOMContentLoaded', function () {
    const toggleButton = document.getElementById('toggle-button');
    const footnotesContainer = document.getElementById('footnotes');
    let isExpanded = false;

    toggleButton.addEventListener('click', function () {
        const footnotes = footnotesContainer.querySelectorAll('div');
        
        if (isExpanded) {
            footnotes.forEach((footnote, index) => {
                if (index < 3) {
                footnote.style.display = 'block';
                } else {
                footnote.style.display = 'none';
                }
            });
            toggleButton.textContent = 'Mehr anzeigen';
        } else {
            footnotes.forEach((footnote) => {
            footnote.style.display = 'block';
            });
            toggleButton.textContent = 'Weniger anzeigen';
        }

        isExpanded = !isExpanded;
    });
});
